import * as THREE from 'three';

// https://stackoverflow.com/questions/42348495/three-js-find-all-points-where-a-mesh-intersects-a-plane
// https://discourse.threejs.org/t/plane-intersects-mesh-with-three-js-r125/34543/5


// var a = new THREE.Vector3();
// var b = new THREE.Vector3();
// var c = new THREE.Vector3();


/**
 * Get intersection points between a mesh and a plane
 * @param {THREE.Mesh} refMesh 
 * @param {THREE.Plane} plane
 * @param {number} offset
 * @param {boolean} flgX
 * @param {boolean} isFlg
 * @returns {THREE.Vector3[]} points
 */
export function drawIntersectionPoints(refMesh, plane, offset, flgX=true, isFlg=true) {
  var pointsOfIntersection = [];
  var points = [];

  var a = new THREE.Vector3();
  var b = new THREE.Vector3();
  var c = new THREE.Vector3();

  /*
  var mathPlane = new THREE.Plane();
  plane.localToWorld(planePointA.copy(plane.geometry.vertices[plane.geometry.faces[0].a]));
  plane.localToWorld(planePointB.copy(plane.geometry.vertices[plane.geometry.faces[0].b]));
  plane.localToWorld(planePointC.copy(plane.geometry.vertices[plane.geometry.faces[0].c]));
  mathPlane.setFromCoplanarPoints(planePointA, planePointB, planePointC);
  */
  var mathPlane = plane;
  
  var vertices = []
  var cnt = 3
  var length = refMesh.geometry.attributes.position.array.length
  const toleranceCenter = 3

  for(var i = 0; i < Math.ceil(length / cnt); i++) {
    var j = i * cnt;
    var p = new THREE.Vector3(...refMesh.geometry.attributes.position.array.slice(j, j + cnt)); 
    vertices.push(p);
  }

  var lineAB = 0;
  var lineBC = 0;
  var lineCA = 0;

  const lenPoints = (refMesh.geometry.index === null) ? vertices.length/cnt : refMesh.geometry.index.array.length/cnt
  for (var i = 0; i < lenPoints; i++) {
    if (refMesh.geometry.index === null) { // for non-indexed BufferGeometry
      refMesh.localToWorld(a.copy(vertices[cnt*i]));
      refMesh.localToWorld(b.copy(vertices[cnt*i+1]));
      refMesh.localToWorld(c.copy(vertices[cnt*i+2]));
    } else { // for indexed BufferGeometry
      refMesh.localToWorld(a.copy(vertices[refMesh.geometry.index.array[cnt*i]]));
      refMesh.localToWorld(b.copy(vertices[refMesh.geometry.index.array[cnt*i+1]]));
      refMesh.localToWorld(c.copy(vertices[refMesh.geometry.index.array[cnt*i+2]]));
    }

    if (isFlg) {
      if (flgX) {
        if ((Math.abs(a.x-offset)) > toleranceCenter) {
          continue
        }
      } else {
        if ((a.y-offset) > toleranceCenter) {
          continue
        }
      }
    }

    lineAB = new THREE.Line3(a, b);
    lineBC = new THREE.Line3(b, c);
    lineCA = new THREE.Line3(c, a);
    pointsOfIntersection = setPointOfIntersection(lineAB, mathPlane, i, points);
    pointsOfIntersection = setPointOfIntersection(lineBC, mathPlane, i, points);
    pointsOfIntersection = setPointOfIntersection(lineCA, mathPlane, i, points);
  };

  return points
}

function setPointOfIntersection(line, plane, faceIdx, pointsOfIntersection) {
  const pointOfIntersection = new THREE.Vector3();

  if (plane.intersectLine(line, pointOfIntersection)) {
    let p = pointOfIntersection.clone();
    
    let isSame = false
    //if (length > 0) { // Delete close point
    //  isSame = p.equals(pointsOfIntersection.vertices[length-1], 1);
      //isSame = p.equals(pointsOfIntersection[length-1], 1);
    //}

    if (!isSame) {
      p.faceIndex = faceIdx;
      p.checked = false;
      
      pointsOfIntersection.push(p);
    }
  };

  return pointsOfIntersection;
}

export function getContours(points, contours, firstRun) {
  //console.log("firstRun:", firstRun);

  let contour = [];

  // find first line for the contour
  let firstPointIndex = 0;
  let secondPointIndex = 0;
  let firstPoint, secondPoint;

  for (let i = 0; i < points.length; i++) {
    if (points[i].checked == true) continue;
    firstPointIndex = i;
    firstPoint = points[firstPointIndex];
    firstPoint.checked = true;
    secondPointIndex = getPairIndex(firstPoint, firstPointIndex, points);
    secondPoint = points[secondPointIndex];
    secondPoint.checked = true;
    contour.push(firstPoint);
    contour.push(secondPoint);
    break;
  }
  
  contour = getContour(secondPoint, points, contour);

  contours.push(contour);
  let allChecked = 0;
  
  points.forEach(p => { allChecked += p.checked == true ? 1 : 0; });
  //console.log("allChecked: ", allChecked == points.length);
  //if (allChecked != points.length) { return getContours(points, contours, false); }
  
  return contours;
}

function getContour(currentPoint, points, contour){
  const tolerance = 0.001

  let p1Index = getNearestPointIndex(currentPoint, points);
  let p1 = points[p1Index];
  p1.checked = true;
  let p2Index = getPairIndex(p1, p1Index, points);
  let p2 = points[p2Index];
  p2.checked = true;
  const dist = p2.distanceTo(contour[0])
  //let isClosed = p2.equals(contour[0], tolerance);
  let isClosed = dist < tolerance
  //console.log(contour.length)
  //console.log(dist)

  //if (!isClosed)
  if (contour.length!=points.length) {
  //if (contour.length < 1000) {
    contour.push(p2);
    return getContour(p2, points, contour);
  } else {
    contour.push(contour[0]);
    return contour;
  }
}

// TODO: it is not the nearest
function getNearestPointIndex(point, points){
  const tolerance = 30
  let index = 0;
  var dist = 0;
  var minDist = 9999;

  for (let i = 0; i < points.length; i++){
    let p = points[i];
    dist = p.distanceTo(point)
    //if (p.checked == false && p.equals(point, tolerance)){ 
    if (p.checked == false){
      if (dist < minDist) {
        minDist = dist;
        index = i
      } 
      //index = i;
      //break;
    }
  }
  return index;
}

function getPairIndex(point, pointIndex, points) {
  let index = 0;
  for (let i = 0; i < points.length; i++) {
    let p = points[i];
    if (i != pointIndex && p.checked == false && p.faceIndex == point.faceIndex) { // # same face
      index = i;
      break;
    }
  }
  return index;
}